import { SelectC } from 'components'
import { useLoadOrderPaymentTerms } from 'modules/orders/hooks/useLoadOrderPaymentTerms'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useDebounce } from 'utils'

export function SelectPaymentTerms({ onChange, disabled }: any) {
  const [search, setSearch] = useState('')
  const searchDebounced = useDebounce(search, 500)
  const { setValue, watch } = useFormContext()
  const [unityId] = watch(['unity'])

  const { data, isLoading } = useLoadOrderPaymentTerms({
    search: searchDebounced,
    unityId: unityId?.id || ''
  })

  const handleChangeCustomer = (value: string, reason: string) => {
    if (reason === 'input' || reason === 'clear') setSearch(value)
  }
  return (
    <SelectC
      name="paymentTerm"
      options={data?.data}
      onInputChange={(e, value, reason) => handleChangeCustomer(value, reason)}
      label="Condição de Pagamento"
      loading={isLoading}
      getOptionLabel={(option: any) => option?.name}
      disabled={disabled}
      onChange={() => {
        onChange?.()
        setValue('installments', [])
        setValue('entryPercent', 0)
        setValue('entryValue', 0)
      }}
    />
  )
}
